import type { TraceErrorObject } from 'owa-trace';

export interface ErrorComponentProps {
    error: Error;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    windowIcons?: React.FunctionComponent<any>;
}

export enum ErrorComponentType {
    Full,
    Simple,
    None,
}

export interface ErrorBoundaryProps {
    children?: React.ReactNode;
    onError?: (error: TraceErrorObject, errorInfo: React.ErrorInfo) => void;
    type?: ErrorComponentType;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    fullErrorComponent?: React.ComponentType<
        {
            error: Error;
        } & any
    >;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    fullErrorComponentProps?: any;
    suppressErrorReport?: boolean;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    windowIcons?: React.FunctionComponent<any>;
}

export interface ErrorBoundaryState {
    error?: TraceErrorObject;
}
